module.exports = __webpack_public_path__ + "img/personnel_access_feature_01.11fcaf00.jpg";